/** @prettier */

/**
 * ロジック関連関数一覧
 */

import * as apiIF from '../Type/api';

/**
 * ロジック設定をロジック編集APIに渡す形に変換する
 * @param logic 変換するロジック設定
 * @returns 変換されたロジック設定
 */
const convertLogic = (logic: apiIF.res.settingLogic) => {
  let result: apiIF.reqParameters.settingLogic = {};

  //未設定のロジックの場合
  if (logic['control'] === '') return result;

  for (const [item, value] of Object.entries(logic)) {
    switch (item) {
      case 'priority-level':
        result[item] = value;
        break;
      case 'control':
        if (value === '') break;
        result[item] = value;
        break;
      case 'scope':
        if (value === '') break;
        result[item] = value;
        break;
      case 'target-id':
        if (value === '') break;
        result[item] = value;
        break;
      case 'target-name':
        //制御対象名は入力しない
        break;
      case 'trigger':
        if (value === '') break;
        result[item] = value;
        break;
      case 'threshold':
        if (value === '') break;
        result[item] = value;
        break;
      case 'range':
        if (value === '') break;
        result[item] = value;
        break;
      case 'action':
        if (
          'notify-authority' in value &&
          value['notify-authority'].length > 0
        ) {
          const action: apiIF.reqParameters.notice = {
            'notify-authority': value['notify-authority'],
          };
          result['action'] = action;
        } else {
          let action: apiIF.reqParameters.command = {};
          if ('run-stop' in value && value['run-stop'] !== '') {
            action['run-stop'] = value['run-stop'];
          }
          if ('operation-mode' in value && value['operation-mode'] !== '') {
            action['operation-mode'] = value['operation-mode'];
          }
          if (
            'preset-temperature' in value &&
            value['preset-temperature'] !== ''
          ) {
            action['preset-temperature'] = value['preset-temperature'];
          }
          if ('air-flow' in value && value['air-flow'] !== '') {
            action['air-flow'] = value['air-flow'];
          }
          result['action'] = action;
        }
        break;
    }
  }

  return result;
};

export default convertLogic;
